import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { SET_STORE_PAGE_URL } from "../../database/store-data";
import { STORE_CSID } from "../../database/store-names";
import { PT_SIGNIN } from "../stack/paths/pt-profile";
import { PT_CART } from "../stack/paths/pt-cart";
import { CSP, ENCRYPT_STORAGE } from "../../config/config";
import HeaderCommon from "../../components/header-tab/fixed-common-header";
import OrderStatus from "../../pages/cart/pg-orderstatus";
import Paymode from "../../pages/cart/pg-paymode";
import Footer from "../../components/footer-tab/fixedfooter";
import Cart from "../../pages/cart/pg-cart";

export function RTCart(props) {
  const navigate = useNavigate();
  const params = useParams();
  const isAvCartSigninRequired =
    CSP === "AV" && Number(ENCRYPT_STORAGE.getItem(STORE_CSID) || 0) <= 0;

  useEffect(() => {
    if (!isAvCartSigninRequired) {
      return;
    }

    SET_STORE_PAGE_URL(PT_CART);
    navigate(PT_SIGNIN, { replace: true });
  }, [isAvCartSigninRequired, navigate]);

  if (isAvCartSigninRequired) {
    return null;
  }

  return (
    <>
      <ToastContainer />
      <Cart navigate={navigate} params={params} />
      <Footer navigate={navigate} params={params} />
    </>
  );
}

export function RTPaymode(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <HeaderCommon navigate={navigate} params={params} />
      <Paymode navigate={navigate} params={params} />
    </>
  );
}

export function RTOrderStatus(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <HeaderCommon navigate={navigate} params={params} />
      <OrderStatus navigate={navigate} params={params} />
      <Footer navigate={navigate} params={params} />
    </>
  );
}
